import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import _ from "lodash";
import React, { useEffect, useRef } from "react";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const dataSectionsBackgroundColors = (colorArrayReq) => {
   let origColors = [
      "rgba(43,114,185,255)",
      "rgba(161,208,255,255)",
      "rgba(248,144,80,255)",
      "rgba(247,111,30,255)",
      "rgba(242,242,242,255)",
   ];
   return _.map(colorArrayReq, (q, idx) => {
      return idx < 4 ? origColors[idx] : origColors[idx % 4];
   });
};

function shapeData(data) {
   // const itemCount = data.length;
   // const labels = _.map(data, c => { return c.label });
   return {
      labels: _.map(data, c => { return c.label }),
      datasets: [
         {
            data: _.map(data, c => { return c.value }),
            backgroundColor: dataSectionsBackgroundColors(data),
            borderColor: dataSectionsBackgroundColors(data),
            borderWidth: 1,
            datalabels: {
               anchor: 'middle'
            }
         },
      ],
   };
}

function shapeOptions(props) {
   const { usePercentSign, data } = props;
   return {
      aspectRatio: 1,
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
         legend: {
            position: "right",
         },
         datalabels: {
            backgroundColor: function (context) {
               return context.dataset.backgroundColor;
            },
            color: 'white',
            display: function (context) {
               var dataset = context.dataset;
               var count = dataset.data.length;
               var value = dataset.data[context.dataIndex];
               return value > count * 1.5;
            },
            font: {
               weight: 'bold'
            },
            padding: 6,
            formatter: function (value, context) {
               if (usePercentSign) {
                  value = Math.round(value / _.sumBy(data, i => { return i.value }) * 100);
                  value = value + '%';
               }
               return value;
            }
         },
      },
      legend: {
         display: false,
      },
   }
}

// This component is only used on the On Time Delivery Report which was moved to Power BI
export default function DoughnutChart(props) {
   const chartRef = useRef();
   //let parentNode;  // Should this have a setter ??

   useEffect(() => {
      //parentNode = chartRef.current?.parentNode
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [chartRef]);

   if (props && props.data) {
      const data = shapeData(props.data);
      const options = shapeOptions(props);
      return <div className={"chart-container"} ref={chartRef}>
         <Doughnut data={data} options={options} />
      </div>;
   } else {
      console.error("Doughnut chart requires 'data' as a prop")
   }
   return null;
}
